module.exports = __webpack_public_path__ + "media/images/slide_prev_btn_sp-973930ba0e2c3fca949e41f485d79faa.png";